<template>
  <v-layout row wrap>
    <v-flex x12>
      <v-card>
        <v-toolbar dense card class="elevation-2">
          <v-toolbar-title class="body-2 beez-bold">Landscape</v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom v-if="can('LANDSCAPE_GRAPH_DIRECTION')">
            <v-btn
              icon
              :color="
                options.layout.hierarchical.direction === 'UD'
                  ? 'secondary'
                  : ''
              "
              slot="activator"
              v-if="options.layout.hierarchical.enabled"
              @click="toogleDirection()"
            >
              <v-icon>arrow_downward</v-icon>
            </v-btn>
            <span>Toggle graph direction</span>
          </v-tooltip>
          <v-tooltip bottom v-if="can('LANDSCAPE_DEPENDENCY_ARROWS')">
            <v-btn
              icon
              slot="activator"
              :color="options.edges.arrows.middle.enabled ? 'secondary' : ''"
              @click="
                options.edges.arrows.middle.enabled = !options.edges.arrows
                  .middle.enabled
                redrawNetwork()
              "
            >
              <v-icon>mdi-ray-end-arrow</v-icon>
            </v-btn>
            <span>Toggle dependency arrows</span>
          </v-tooltip>
          <v-tooltip bottom v-if="can('LANDSCAPE_REFRESH')">
            <v-btn flat icon slot="activator" @click="redrawNetwork()">
              <v-icon>cached</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
        </v-toolbar>
        <div ref="myNetwork" class="network"></div>
        <v-dialog v-model="networkLoading" hide-overlay persistent width="300">
          <v-card>
            <v-card-text>
              Please stand by
              <v-progress-linear color="accent" indeterminate class="mb-0" />
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
          persistent
          v-model="showModel"
          max-width="70%"
          content-class="honey-popup"
        >
          <v-card>
            <v-toolbar dense card class="elevation-2">
              <div class="text-lg-left beez-bold ">
                Selected item details
              </div>
              <v-spacer />
              <v-btn flat icon @click="showModel = !showModel">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text v-if="selectedNode">
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 md6 lg4>
                        <div class="text-xs-left">
                          <br />
                          <div>Unique Identifier</div>
                          <div class="subheading">{{ selectedNode.hexId }}</div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex xs12 md6 lg4>
                        <div class="text-xs-left">
                          <br />
                          <div>Name</div>
                          <div class="subheading">{{ selectedNode.name }}</div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex xs12 md6 lg4>
                        <div class="text-xs-left">
                          <br />
                          <div>Description</div>
                          <div class="subheading">
                            {{ selectedNode.description }}
                          </div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex xs12 md6 lg4 v-if="selectedNode.type === 'Bot'">
                        <div class="text-xs-left">
                          <br />
                          <div>Hive Description</div>
                          <div class="subheading">
                            {{ selectedNode.description }}
                          </div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                        lg4
                        v-else-if="selectedNode.type === 'Workflow'"
                      >
                        <div class="text-xs-left">
                          <br />
                          <div>Workflow Process Id</div>
                          <div class="subheading">
                            {{ selectedNode.processId }}
                          </div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                        lg4
                        v-else-if="selectedNode.itemType === 'Hive'"
                      >
                        <div class="text-xs-left">
                          <br />
                          <div>Hive Type</div>
                          <div class="subheading">{{ selectedNode.type }}</div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex xs12 md6 lg4>
                        <div class="text-xs-left">
                          <br />
                          <div>Created By</div>
                          <div class="subheading">
                            {{ selectedNode.createdByUser }}
                          </div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex xs12 md6 lg4>
                        <div class="text-xs-left">
                          <br />
                          <div>Created At</div>
                          <div class="subheading">
                            {{ selectedNode.createdAtLocal }}
                          </div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                        lg4
                        v-if="
                          selectedNode.type === 'Bot' ||
                            selectedNode.type === 'Workflow'
                        "
                      >
                        <div class="text-xs-left">
                          <br />
                          <div>Last Successful Execution</div>
                          <div class="subheading">
                            {{ selectedNode.lastSuccessfulAtLocal }}
                          </div>
                          <br />
                        </div>
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                        lg4
                        v-if="
                          selectedNode.type === 'Bot' ||
                            selectedNode.type === 'Workflow'
                        "
                      >
                        <div class="text-xs-left">
                          <br />
                          <div>Last Failed Execution</div>
                          <div class="subheading">
                            {{ selectedNode.lastFailedAtLocal }}
                          </div>
                          <br />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 style="padding-bottom: 20px">
                    <v-chip
                      class="pull-left"
                      v-if="selectedNode.active === true"
                    >
                      <v-avatar>
                        <v-icon class="green--text"
                          >check_circle_outline
                        </v-icon>
                      </v-avatar>
                      Active
                    </v-chip>
                    <v-chip
                      class="pull-left"
                      v-if="selectedNode.active === false"
                    >
                      <v-avatar>
                        <v-icon class="grey--text">highlight_off</v-icon>
                      </v-avatar>
                      InActive
                    </v-chip>
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                    lg4
                    v-if="
                      selectedNode.type === 'Bot' ||
                        selectedNode.type === 'Workflow'
                    "
                  >
                    <v-layout row wrap>
                      <v-flex xs2>
                        <v-avatar tile>
                          <v-icon class="accent--text" large>timer</v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs10>
                        <div class="text-xs-left">
                          <div class="subheading ">
                            {{ selectedNode.avgExecutionTime }}
                          </div>
                          <div>Average Resolution Time</div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    d-flex
                    xs12
                    md6
                    lg4
                    v-if="selectedNode.type === 'Bot'"
                  >
                    <v-layout row wrap>
                      <v-flex xs2>
                        <v-avatar tile>
                          <v-icon class="accent--text" large
                            >attach_money
                          </v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs10>
                        <div class="text-xs-left">
                          <div class="subheading">
                            {{ selectedNode.fteReduction }}
                          </div>
                          <div>Effort savings per run</div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    d-flex
                    xs12
                    md6
                    lg4
                    v-if="selectedNode.type === 'Bot'"
                  >
                    <v-layout row wrap>
                      <v-flex xs2>
                        <v-avatar tile>
                          <v-icon class="accent--text" large
                            >attach_money
                          </v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs10>
                        <div class="text-xs-left">
                          <div class="subheading ">
                            {{ selectedNode.effortSavings }}
                          </div>
                          <div>Total Effort savings</div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-btn
                  flat
                  :color="$vuetify.dark ? 'secondary' : ''"
                  :outline="$vuetify.dark"
                  class="text-capitalize mx-2"
                  :to="{
                    name:
                      selectedNode.itemType === 'Hive'
                        ? 'hive-detail'
                        : selectedNode.type === 'Bot'
                        ? 'bot-detail'
                        : 'workflow-detail',
                    params: { hexId: selectedNode.hexId }
                  }"
                >
                  <v-icon>
                    reply
                  </v-icon>
                  <span class="pl-2">Go To Service</span>
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { DataSet, Network } from 'vis-network/standalone/umd/vis-network.min'
import $ from 'jquery'
import moment from 'moment'
import u from '@/utils'
import { mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      options: {
        physics: {
          hierarchicalRepulsion: {
            avoidOverlap: 1
          }
        },
        layout: {
          improvedLayout: true,
          hierarchical: {
            enabled: true,
            levelSeparation: 150,
            nodeSpacing: 100,
            treeSpacing: 200,
            blockShifting: true,
            edgeMinimization: true,
            parentCentralization: false,
            direction: 'UD', // UD, DU, LR, RL
            sortMethod: 'hubsize' // hubsize, directed
          }
        },
        nodes: {
          shapeProperties: {
            interpolation: false
          },
          borderWidth: 5,
          size: 20,
          shadow: true,
          widthConstraint: {
            maximum: 70
          },
          color: {
            border: '#42A85F',
            background: '#42A85F',
            highlight: {
              border: '#ff9400',
              background: '#D2E5FF'
            },
            hover: {
              border: '#ff9400',
              background: '#D2E5FF'
            }
          },
          font: {
            size: 8,
            color: '#424242',
            strokeWidth: 0.2,
            strokeColor: '#424242'
          }
        },
        edges: {
          width: 1,
          widthConstraint: {
            maximum: 70
          },
          color: {
            color: '#dcdcdc',
            highlight: '#ff9400',
            hover: '#ff9400',
            inherit: 'both',
            opacity: 1.0
          },
          arrows: {
            middle: { enabled: false, scaleFactor: 1, type: 'arrow' }
          }
        },
        groups: {
          Beekeeper: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Beekeeper.svg',
              selected: '/images/Beekeeper.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            level: 0,
            size: 35
          },
          SAP: {
            shape: 'circularImage',
            image: {
              unselected: '/images/SAP.svg',
              selected: '/images/SAP.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            level: 1,
            size: 25
          },
          SAPBlocked: {
            shape: 'circularImage',
            image: {
              unselected: '/images/SAP.svg',
              selected: '/images/SAP.svg'
            },
            color: {
              border: '#B82E24',
              background: '#B82E24'
            },
            level: 1,
            size: 25
          },
          SAPDeactive: {
            shape: 'circularImage',
            image: {
              unselected: '/images/SAPDeactive.svg',
              selected: '/images/SAPDeactive.svg'
            },
            color: {
              border: '#808080',
              background: '#808080'
            },
            level: 1,
            size: 25
          },
          RPA: {
            shape: 'circularImage',
            image: {
              unselected: '/images/RPA.svg',
              selected: '/images/RPA.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            level: 1,
            size: 25
          },
          RPABlocked: {
            shape: 'circularImage',
            image: {
              unselected: '/images/RPA.svg',
              selected: '/images/RPA.svg'
            },
            color: {
              border: '#B82E24',
              background: '#B82E24'
            },
            level: 1,
            size: 25
          },
          RPADeactive: {
            shape: 'circularImage',
            image: {
              unselected: '/images/RPADeactive.svg',
              selected: '/images/RPADeactive.svg'
            },
            color: {
              border: '#808080',
              background: '#808080'
            },
            level: 1,
            size: 25
          },
          API: {
            shape: 'circularImage',
            image: {
              unselected: '/images/API.svg',
              selected: '/images/API.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            level: 1,
            size: 25
          },
          APIBlocked: {
            shape: 'circularImage',
            image: {
              unselected: '/images/API.svg',
              selected: '/images/API.svg'
            },
            color: {
              border: '#B82E24',
              background: '#B82E24'
            },
            level: 1,
            size: 25
          },
          APIDeactive: {
            shape: 'circularImage',
            image: {
              unselected: '/images/APIDeactive.svg',
              selected: '/images/APIDeactive.svg'
            },
            color: {
              border: '#808080',
              background: '#808080'
            },
            level: 1,
            size: 25
          },
          JAVA: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Java.svg',
              selected: '/images/Java.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            level: 1,
            size: 25
          },
          JAVABlocked: {
            shape: 'circularImage',
            image: {
              unselected: '/images/JavaDeactive.svg',
              selected: '/images/JavaDeactive.svg'
            },
            color: {
              border: '#B82E24',
              background: '#B82E24'
            },
            level: 1,
            size: 25
          },
          JAVADeactive: {
            shape: 'circularImage',
            image: {
              unselected: '/images/JavaDeactive.svg',
              selected: '/images/JavaDeactive.svg'
            },
            color: {
              border: '#808080',
              background: '#808080'
            },
            level: 1,
            size: 25
          },
          Bot: {
            shape: 'icon',
            icon: {
              face: 'Material Design Icons',
              code: '\uf6a8',
              size: 50,
              color: '#42A85F'
            },
            level: 2
          },
          BotBlocked: {
            shape: 'icon',
            icon: {
              face: 'Material Design Icons',
              code: '\uf6a8',
              size: 50,
              color: '#B82E24'
            },
            level: 2
          },
          BotDeactive: {
            shape: 'icon',
            icon: {
              face: 'Material Design Icons',
              code: '\uf6a8',
              size: 50,
              color: '#808080'
            },
            level: 2
          },
          Workflow: {
            shape: 'icon',
            icon: {
              face: 'Material Design Icons',
              code: '\uf561',
              size: 50,
              color: '#42A85F'
            },
            level: 3
          },
          WorkflowBlocked: {
            shape: 'icon',
            icon: {
              face: 'Material Design Icons',
              code: '\uf561',
              size: 50,
              color: '#B82E24'
            },
            level: 3
          },
          WorkflowDeactive: {
            shape: 'icon',
            icon: {
              face: 'Material Design Icons',
              code: '\uf561',
              size: 50,
              color: '#808080'
            },
            level: 3
          }
        },
        interaction: {
          hover: true,
          selectable: true,
          multiselect: true,
          zoomView: true,
          navigationButtons: true,
          keyboard: true
        }
      },
      nodes: [],
      edges: [],
      networkData: null,
      network: null,
      nodeMap: null,
      nodeValueMap: null,
      dependencyMap: null,
      blockedNodes: [],
      showBots: false,
      showWorkflows: false,
      showModel: false,
      networkLoading: false,
      selectedNode: null,
      selectedNodes: [],
      moreMenu: false,
      groupMenu: false,
      activeConfirmDialog: false
    }
  },

  mounted() {
    this.networkLoading = true
    this.getData()
  },
  methods: {
    async getData() {
      if (this.hives && this.hives.length === 0) {
        //Wait for initial data to be loaded
        await this.$store.dispatch('fetchHives')
      }
      if (this.bots && this.bots.length === 0) {
        //this.$store.dispatch('fetchBots')
      }
      if (this.workflows && this.workflows.length === 0) {
       // this.$store.dispatch('fetchWorkflows')
      }
      if (this.botsWithProjection && this.botsWithProjection.length === 0) {
        //this.$store.dispatch('fetchBotsWithProjection')
      }
      if (
        this.workflowsWithProjection &&
        this.workflowsWithProjection.length === 0
      ) {
        //this.$store.dispatch('fetchWorkflowsWithProjection')
      }
      this.initNetwork()
    },
    async toogleActive() {
      this.activeConfirmDialog = false
      await Promise.all(
        this.selectedNodes.map(async node => {
          let botPromise
          let workflowPromise
          let hivePromise
          if (node.type === 'Bot') {
            let cloneNode = u.clone(node)
            cloneNode.active = !cloneNode.active
            await this.$store.dispatch('setBotActive', cloneNode).then(() => {
              botPromise = this.$store.dispatch('fetchBots')
              return Promise.resolve(botPromise)
            })
          } else if (node.type === 'Workflow') {
            let cloneNode = u.clone(node)
            cloneNode.active = !cloneNode.active
            await this.$store
              .dispatch('setWorkflowActive', cloneNode)
              .then(() => {
                workflowPromise = this.$store.dispatch('fetchWorkflows')
                return Promise.resolve(workflowPromise)
              })
          } else if (node.itemType === 'Hive') {
            let hiveUpdateBody = {
              active: !node.active
            }
            await this.$store
              .dispatch('updateHive', {
                body: hiveUpdateBody,
                hexId: node.hexId
              })
              .then(async () => {
                hivePromise = this.$store.dispatch('fetchHives')
                return Promise.resolve(hivePromise)
              })
          }
        })
      )
      this.redrawNetwork()
    },
    toogleLayout() {
      this.options.layout.hierarchical.enabled = !this.options.layout
        .hierarchical.enabled
      this.redrawNetwork()
    },
    tooglePhysicsLayout() {
      this.options.physics.enabled = !this.options.physics.enabled
      this.redrawNetwork()
    },
    toogleDirection() {
      if (this.options.layout.hierarchical.direction === 'UD') {
        this.options.layout.hierarchical.direction = 'DU'
      } else {
        this.options.layout.hierarchical.direction = 'UD'
      }
      this.redrawNetwork()
    },
    getGraphData() {
      let hives = this.$store.getters.getHives
      let bots = this.$store.getters.getBots
      let botsProjection = this.$store.getters.getBotsWithProjection
      let workflows = this.$store.getters.getWorkflow
      let workflowsProjection = this.$store.getters.getWorkflowWithProjection
      this.dependencyMap = new Map()
      this.blockedNodes = []
      this.dependencyMap.set('Beekeeper', [])
      hives.forEach(hive => {
        this.dependencyMap.set(hive.hexId, [])
        this.dependencyMap.get('Beekeeper').push(hive.hexId)
      })
      if (this.showBots) {
        bots = bots.map(bot => {
          let projection = botsProjection.find(
            projection => projection.hexId === bot.hexId
          )
          bot = { ...bot, ...projection }
          if (bot.hive) {
            bot.hive = hives.find(hive => hive.hexId === bot.hive.hexId)
          }
          return bot
        })
        bots.forEach(bot => {
          this.dependencyMap.set(bot.hexId, [])
          if (bot.hive.hexId) {
            this.dependencyMap.get(bot.hive.hexId).push(bot.hexId)
          }
        })
        workflows = workflows.map(workflow => {
          let projection = workflowsProjection.find(
            projection => projection.hexId === workflow.hexId
          )
          workflow = { ...workflow, ...projection }
          return workflow
        })
        if (this.showWorkflows) {
          workflows.forEach(workflow => {
            this.dependencyMap.set(workflow.hexId, [])
            let xmlDoc = $.parseXML(workflow.data)
            let $xml = $(xmlDoc)
            let _self = this
            $xml
              .find('bpmn2\\:process')
              .children()
              .each(function(i, child) {
                if (child.nodeName === 'bpmn2:serviceTask') {
                  if (child.getAttribute('bot:bot') != null) {
                    if (
                      _self.dependencyMap.get(child.getAttribute('bot:bot'))
                    ) {
                      _self.dependencyMap
                        .get(child.getAttribute('bot:bot'))
                        .push(workflow.hexId)
                    }
                  }
                }
              })
            $xml
              .find('bpmn\\:process')
              .children()
              .each(function(i, child) {
                if (child.nodeName === 'bpmn:serviceTask') {
                  if (child.getAttribute('bot:bot') != null) {
                    if (
                      _self.dependencyMap.get(child.getAttribute('bot:bot'))
                    ) {
                      _self.dependencyMap
                        .get(child.getAttribute('bot:bot'))
                        .push(workflow.hexId)
                    }
                  }
                }
              })
            $xml
              .find('bpmn2\\:process')
              .children()
              .each(function(i, child) {
                if (child.nodeName === 'bpmn2:serviceTask') {
                  if (child.getAttribute('tulip:bot') != null) {
                    if (
                      _self.dependencyMap.get(child.getAttribute('tulip:bot'))
                    ) {
                      _self.dependencyMap
                        .get(child.getAttribute('tulip:bot'))
                        .push(workflow.hexId)
                    }
                  }
                }
              })
            $xml
              .find('bpmn\\:process')
              .children()
              .each(function(i, child) {
                if (child.nodeName === 'bpmn:serviceTask') {
                  if (child.getAttribute('tulip:bot') != null) {
                    if (
                      _self.dependencyMap.get(child.getAttribute('tulip:bot'))
                    ) {
                      _self.dependencyMap
                        .get(child.getAttribute('tulip:bot'))
                        .push(workflow.hexId)
                    }
                  }
                }
              })
          })
        }
      }
      hives.forEach(hive => {
        if (!hive.active) {
          this.addDependencies(hive.hexId)
        }
      })
      if (this.showBots) {
        bots.forEach(bot => {
          if (!bot.active) {
            this.addDependencies(bot.hexId)
          }
        })
        if (this.workflows) {
          workflows.forEach(workflow => {
            if (!workflow.active) {
              this.addDependencies(workflow.hexId)
            }
          })
        }
      }
      return { hives, bots, workflows }
    },
    addDependencies(hexId) {
      let dependenciesArray = this.dependencyMap.get(hexId)
      if (dependenciesArray) {
        dependenciesArray.forEach(hexId => {
          this.blockedNodes.push(hexId)
          this.addDependencies(hexId)
        })
      }
    },
    initNetwork() {
      // create a network
      if (!this.networkLoading) {
        this.networkLoading = true
      }
      let { hives, bots, workflows } = this.getGraphData()

      let idCount = 0
      this.nodeMap = new Map()
      this.nodeValueMap = new Map()
      this.nodes = []
      this.edges = []
      this.nodes.push({
        id: idCount,
        label: 'Beekeeper',
        group: 'Beekeeper'
      })
      this.nodeMap.set('beekeeper', '0')
      this.nodeValueMap.set(idCount, { type: 'Beekeeper', hexId: null })
      hives.forEach(hive => {
        ++idCount
        this.nodeMap.set(hive.hexId, idCount.toString())
        this.nodeValueMap.set(idCount, { type: 'Hive', hexId: hive.hexId })
        if (hive.active) {
          if (this.blockedNodes.indexOf(hive.hexId) !== -1) {
            this.nodes.push({
              id: idCount,
              label: hive.name,
              group: hive.hiveType + 'Blocked'
            })
          } else {
            this.nodes.push({
              id: idCount,
              label: hive.name,
              group: hive.hiveType
            })
          }
        } else {
          this.nodes.push({
            id: idCount,
            label: hive.name,
            group: hive.hiveType + 'Deactive'
          })
        }
        this.edges.push({ from: 0, to: idCount })
      })

      if (this.showBots) {
        let selectedHiveIds = []
        this.selectedNodes.map(node => {
          if (node.itemType === 'Hive') {
            selectedHiveIds.push(node.hexId)
          }
        })

        bots.forEach(bot => {
          if (
            selectedHiveIds.length === 0 ||
            selectedHiveIds.find(item => item === bot.hive.hexId)
          ) {
            ++idCount
            this.nodeMap.set(bot.hexId, idCount.toString())
            this.nodeValueMap.set(idCount, { type: 'Bot', hexId: bot.hexId })
            let label = this.wordwrap(bot.name, 15)
            if (bot.active) {
              if (this.blockedNodes.indexOf(bot.hexId) !== -1) {
                this.nodes.push({
                  id: idCount,
                  label: label,
                  title: bot.name,
                  group: 'BotBlocked',
                  type: bot.hive.hiveType.toString()
                })
              } else {
                this.nodes.push({
                  id: idCount,
                  label: label,
                  title: bot.name,
                  group: 'Bot',
                  type: bot.hive.hiveType.toString()
                })
              }
            } else {
              this.nodes.push({
                id: idCount,
                label: label,
                title: bot.name,
                group: 'BotDeactive',
                type: bot.hive.hiveType.toString()
              })
            }
            this.edges.push({
              from: parseInt(this.nodeMap.get(bot.hive.hexId), 0),
              to: idCount
            })
          }
        })
        if (this.showWorkflows) {
          workflows.forEach(workflow => {
            ++idCount
            this.nodeMap.set(workflow.hexId, idCount.toString())
            this.nodeValueMap.set(idCount, {
              type: 'Workflow',
              hexId: workflow.hexId
            })
            let label = this.wordwrap(workflow.name, 15)
            if (workflow.active) {
              if (this.blockedNodes.indexOf(workflow.hexId) !== -1) {
                this.nodes.push({
                  id: idCount,
                  label: label,
                  title: workflow.name,
                  group: 'WorkflowBlocked'
                })
              } else {
                this.nodes.push({
                  id: idCount,
                  label: label,
                  title: workflow.name,
                  group: 'Workflow'
                })
              }
            } else {
              this.nodes.push({
                id: idCount,
                label: label,
                title: workflow.name,
                group: 'WorkflowDeactive'
              })
            }

            let xmlDoc = $.parseXML(workflow.data)
            let $xml = $(xmlDoc)
            let _self = this
            $xml
              .find('bpmn2\\:process')
              .children()
              .each(function(i, child) {
                if (child.nodeName === 'bpmn2:serviceTask') {
                  if (child.getAttribute('bot:bot') != null) {
                    _self.edges.push({
                      from: parseInt(
                        _self.nodeMap.get(child.getAttribute('bot:bot')),
                        0
                      ),
                      to: idCount
                    })
                  }
                }
              })

            $xml
              .find('bpmn\\:process')
              .children()
              .each(function(i, child) {
                if (child.nodeName === 'bpmn:serviceTask') {
                  if (child.getAttribute('bot:bot') != null) {
                    _self.edges.push({
                      from: parseInt(
                        _self.nodeMap.get(child.getAttribute('bot:bot')),
                        0
                      ),
                      to: idCount
                    })
                  }
                }
              })
            $xml
              .find('bpmn2\\:process')
              .children()
              .each(function(i, child) {
                if (child.nodeName === 'bpmn2:serviceTask') {
                  if (child.getAttribute('tulip:bot') != null) {
                    _self.edges.push({
                      from: parseInt(
                        _self.nodeMap.get(child.getAttribute('tulip:bot')),
                        0
                      ),
                      to: idCount
                    })
                  }
                }
              })

            $xml
              .find('bpmn\\:process')
              .children()
              .each(function(i, child) {
                if (child.nodeName === 'bpmn:serviceTask') {
                  if (child.getAttribute('tulip:bot') != null) {
                    _self.edges.push({
                      from: parseInt(
                        _self.nodeMap.get(child.getAttribute('tulip:bot')),
                        0
                      ),
                      to: idCount
                    })
                  }
                }
              })
          })
        }
      } else {
        this.showWorkflows = false
      }

      // create a network
      let container = this.$refs.myNetwork
      this.networkData = {
        nodes: new DataSet(this.nodes),
        edges: new DataSet(this.edges)
      }
      let containerHeight = window.innerHeight * 0.8

      this.options.height = String(containerHeight)
      this.network = new Network(container, this.networkData, this.options)

      let _self = this
      this.network.on('doubleClick', function(params) {
        if (params.nodes.length === 1) {
          if (_self.network.isCluster(params.nodes[0]) === true) {
            _self.network.openCluster(params.nodes[0], function(
              clusterPosition,
              containedNodesPositions
            ) {
              // var newPositions = {};
              // // clusterPosition = {x:clusterX, y:clusterY};
              // // containedNodesPositions = {nodeId:{x:nodeX,y:nodeY}, nodeId2....}
              // newPositions[nodeId] = {x:newPosX, y:newPosY};
              return containedNodesPositions
            })
            _self.network.stabilize()
          }
        }
        let obj = null
        if (params.nodes[0]) {
          let selectedNode = _self.nodeValueMap.get(params.nodes[0])
          if (selectedNode) {
            if (selectedNode.type && selectedNode.type === 'Bot') {
              let hexId = selectedNode.hexId
              obj = bots.find(o => o.hexId === hexId)
              _self.selectedNode = _self.fillSelectedObj(obj, 'Bot')
              _self.showModel = true
            } else if (selectedNode.type && selectedNode.type === 'Workflow') {
              let hexId = selectedNode.hexId
              obj = workflows.find(o => o.hexId === hexId)
              _self.selectedNode = _self.fillSelectedObj(obj, 'Workflow')
              _self.showModel = true
            } else if (selectedNode.type && selectedNode.type === 'Hive') {
              let hexId = selectedNode.hexId
              obj = hives.find(o => o.hexId === hexId)
              _self.selectedNode = _self.fillSelectedObj(obj, 'Hive')
              _self.showModel = true
            }
          }
        }
      })
      this.network.on('deselectNode', function(params) {
        _self.selectedNodes = []
        params.nodes.forEach(node => {
          let obj = null
          let selectedNode = _self.nodeValueMap.get(node)
          if (selectedNode) {
            if (selectedNode.type && selectedNode.type === 'Bot') {
              let hexId = selectedNode.hexId
              obj = bots.find(o => o.hexId === hexId)
              _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Bot'))
            } else if (selectedNode.type && selectedNode.type === 'Workflow') {
              let hexId = selectedNode.hexId
              obj = workflows.find(o => o.hexId === hexId)
              _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Workflow'))
            } else if (selectedNode.type && selectedNode.type === 'Hive') {
              let hexId = selectedNode.hexId
              obj = hives.find(o => o.hexId === hexId)
              _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Hive'))
            }
          } else if (params.nodes.length === 1) {
            if (_self.network.isCluster(params.nodes[0]) === true) {
              let clusterNodes = _self.network.getNodesInCluster(
                params.nodes[0]
              )
              clusterNodes.forEach(node => {
                let obj = null
                let selectedNode = _self.nodeValueMap.get(node)
                if (selectedNode) {
                  if (selectedNode.type && selectedNode.type === 'Bot') {
                    let hexId = selectedNode.hexId
                    obj = bots.find(o => o.hexId === hexId)
                    _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Bot'))
                  } else if (
                    selectedNode.type &&
                    selectedNode.type === 'Workflow'
                  ) {
                    let hexId = selectedNode.hexId
                    obj = workflows.find(o => o.hexId === hexId)
                    _self.selectedNodes.push(
                      _self.fillSelectedObj(obj, 'Workflow')
                    )
                  } else if (
                    selectedNode.type &&
                    selectedNode.type === 'Hive'
                  ) {
                    let hexId = selectedNode.hexId
                    obj = hives.find(o => o.hexId === hexId)
                    _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Hive'))
                  }
                }
              })
            }
          }
        })
      })
      this.network.on('selectNode', function(params) {
        _self.selectedNodes = []
        params.nodes.forEach(node => {
          let obj = null
          let selectedNode = _self.nodeValueMap.get(node)
          if (selectedNode) {
            if (selectedNode.type && selectedNode.type === 'Bot') {
              let hexId = selectedNode.hexId
              obj = bots.find(o => o.hexId === hexId)
              _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Bot'))
            } else if (selectedNode.type && selectedNode.type === 'Workflow') {
              let hexId = selectedNode.hexId
              obj = workflows.find(o => o.hexId === hexId)
              _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Workflow'))
            } else if (selectedNode.type && selectedNode.type === 'Hive') {
              let hexId = selectedNode.hexId
              obj = hives.find(o => o.hexId === hexId)
              _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Hive'))
            }
          } else if (params.nodes.length === 1) {
            if (_self.network.isCluster(params.nodes[0]) === true) {
              let clusterNodes = _self.network.getNodesInCluster(
                params.nodes[0]
              )
              clusterNodes.forEach(node => {
                let obj = null
                let selectedNode = _self.nodeValueMap.get(node)
                if (selectedNode) {
                  if (selectedNode.type && selectedNode.type === 'Bot') {
                    let hexId = selectedNode.hexId
                    obj = bots.find(o => o.hexId === hexId)
                    _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Bot'))
                  } else if (
                    selectedNode.type &&
                    selectedNode.type === 'Workflow'
                  ) {
                    let hexId = selectedNode.hexId
                    obj = workflows.find(o => o.hexId === hexId)
                    _self.selectedNodes.push(
                      _self.fillSelectedObj(obj, 'Workflow')
                    )
                  } else if (
                    selectedNode.type &&
                    selectedNode.type === 'Hive'
                  ) {
                    let hexId = selectedNode.hexId
                    obj = hives.find(o => o.hexId === hexId)
                    _self.selectedNodes.push(_self.fillSelectedObj(obj, 'Hive'))
                  }
                }
              })
            }
          }
        })
      })
      this.network.on('afterDrawing', function() {
        _self.networkLoading = false
      })
    },

    redrawNetwork() {
      this.selectedNodes = []
      this.initNetwork()
    },

    toogleBot() {
      this.showBots = !this.showBots
      if (!this.showBots) {
        this.showWorkflows = false
      }
      this.initNetwork()
    },

    clusterByState() {
      this.initNetwork()
      var colors = ['#808080']
      var clusterOptionsByData
      for (var i = 0; i < colors.length; i++) {
        var color = colors[i]
        clusterOptionsByData = {
          joinCondition: function(childOptions) {
            return childOptions.color.background === color // the color is fully defined in the node.
          },
          processProperties: function(clusterOptions, childNodes, childEdges) {
            // var totalMass = 0
            // for (var i = 0; i < childNodes.length; i++) {
            //   totalMass += childNodes[i].mass
            // }
            clusterOptions.mass = 1
            clusterOptions.label =
              'De-activated items' + ': ' + childNodes.length
            return clusterOptions
          },
          clusterNodeProperties: {
            id: 'typeCluster' + color,
            shape: 'circularImage',
            image: {
              unselected: '/images/Sleep.png',
              selected: '/images/Sleep.png'
            },
            level: 4,
            // label: 'De-activated items',
            size: 25,
            borderWidth: 5,
            shadow: true,
            color: {
              border: color,
              background: color,
              highlight: {
                border: '#ff9400',
                background: '#D2E5FF'
              },
              hover: {
                border: '#ff9400',
                background: '#D2E5FF'
              }
            },
            font: {
              size: 14,
              color: '#424242',
              strokeWidth: 0.2,
              strokeColor: '#424242'
            }
          }
        }
        this.network.cluster(clusterOptionsByData)
      }
    },

    clusterBotByType(botType) {
      this.initNetwork()
      let clusterOptionsByData = null
      clusterOptionsByData = {
        joinCondition: function(childOptions) {
          return childOptions.type === botType
        },
        processProperties: function(clusterOptions, childNodes, childEdges) {
          clusterOptions.mass = 1
          clusterOptions.label = botType + ' Bots: ' + childNodes.length
          return clusterOptions
        },
        clusterNodeProperties: {
          id: 'typeCluster' + botType,
          shape: 'circularImage',
          image: {
            unselected: '/images/Bot.svg',
            selected: '/images/Bot.svg'
          },
          level: 2,
          // label: botType + ' Bots',
          size: 25,
          borderWidth: 5,
          shadow: true,
          color: {
            border: '#42A85F',
            background: '#42A85F',
            highlight: {
              border: '#ff9400',
              background: '#D2E5FF'
            },
            hover: {
              border: '#ff9400',
              background: '#D2E5FF'
            }
          },
          font: {
            size: 14,
            color: '#424242',
            strokeWidth: 0.2,
            strokeColor: '#424242'
          }
        }
      }

      this.network.cluster(clusterOptionsByData)
      this.network.stabilize()
    },

    fillSelectedObj(obj, type) {
      function timeConversion(time, unit) {
        time = parseFloat(time)
        switch (unit) {
          case 'Secs':
            if (time > 60) {
              time = time / 60
              if (time > 60) {
                return timeConversion(time, 'Mins')
              } else {
                return [time, 'Mins']
              }
            }
            break
          case 'Mins':
            if (time > 60) {
              time = time / 60
              return [time, 'Hrs']
            }
            break
        }
        return [time, unit]
      }

      this.selectedNode = null
      obj.successRate = 0
      if (!obj.createdBy) {
        obj.createdByUser = 'Admin'
      }
      if (type === 'Workflow') {
        obj.type = 'Workflow'
        obj.hiveId = ''
        obj.hiveName = ''
        obj.hiveDescription = ''
        obj.hivetype = ''
        if (obj.workflowMetric && obj.workflowMetric.totalExecutions > 0) {
          obj.successRate =
            (
              (obj.workflowMetric.totalSuccesses /
                obj.workflowMetric.totalExecutions) *
              100
            )
              .toFixed(2)
              .toString() + ' %'
          obj.failureRate =
            (
              (obj.workflowMetric.totalFailures /
                obj.workflowMetric.totalExecutions) *
              100
            )
              .toFixed(2)
              .toString() + ' %'
          obj.totalExecution = obj.workflowMetric.totalExecutions
          obj.effortSavings = 0
          obj.avgExecutionTime = (
            obj.workflowMetric.totalRunTimeInSecs /
            obj.workflowMetric.totalExecutions
          ).toFixed(2)
          var [time, unit] = timeConversion(obj.avgExecutionTime, 'Secs')
          obj.avgExecutionTime = time.toFixed(2) + ' ' + unit
          if (obj.workflowMetric.lastExecuted) {
            obj.lastExecutedAtLocal = moment(obj.workflowMetric.lastExecuted)
              .utc()
              .local()
              .format('DD MMM YYYY hh:mm:ss a')
          }
          if (obj.workflowMetric.lastFailed) {
            obj.lastFailedAtLocal = moment(obj.workflowMetric.lastFailed)
              .utc()
              .local()
              .format('DD MMM YYYY hh:mm:ss a')
          }
          if (obj.workflowMetric.lastSuccessful) {
            obj.lastSuccessfulAtLocal = moment(
              obj.workflowMetric.lastSuccessful
            )
              .utc()
              .local()
              .format('DD MMM YYYY hh:mm:ss a')
          }
        } else {
          obj.successRate = 0
          obj.failureRate = 0
          obj.totalExecution = 0
          obj.avgExecutionTime = 0
          obj.effortSavings = 0
          obj.lastExecutedAtLocal = ''
          obj.lastFailedAtLocal = ''
          obj.lastSuccessfulAtLocal = ''
        }
      } else if (type === 'Bot') {
        obj.type = 'Bot'
        obj.hiveId = obj.hive.hexId
        obj.hiveName = obj.hive.name
        obj.hiveDescription = obj.hive.description
        obj.hivetype = obj.hive.hiveType
        obj.fteReduction = obj.botTemplate.effortSaved + ' Mins'
        if (obj.botMetric && obj.botMetric.totalExecutions > 0) {
          obj.successRate =
            (
              (obj.botMetric.totalSuccesses / obj.botMetric.totalExecutions) *
              100
            )
              .toFixed(2)
              .toString() + ' %'
          obj.failureRate =
            (
              (obj.botMetric.totalFailures / obj.botMetric.totalExecutions) *
              100
            )
              .toFixed(2)
              .toString() + ' %'
          obj.totalExecution = obj.botMetric.totalExecutions
          obj.effortSavings =
            obj.botMetric.totalExecutions * obj.botTemplate.effortSaved
          var [effort, effortUnit] = timeConversion(obj.effortSavings, 'Mins')
          obj.effortSavings = effort.toFixed(2) + ' ' + effortUnit
          obj.avgExecutionTime = (
            obj.botMetric.totalRunTimeInSecs / obj.botMetric.totalExecutions
          ).toFixed(2)
          var [avgtime, avgunit] = timeConversion(obj.avgExecutionTime, 'Secs')
          obj.avgExecutionTime = avgtime.toFixed(2) + ' ' + avgunit
          if (obj.botMetric.lastExecuted) {
            obj.lastExecutedAtLocal = moment(obj.botMetric.lastExecuted)
              .utc()
              .local()
              .format('DD MMM YYYY hh:mm:ss a')
          }
          if (obj.botMetric.lastFailed) {
            obj.lastFailedAtLocal = moment(obj.botMetric.lastFailed)
              .utc()
              .local()
              .format('DD MMM YYYY hh:mm:ss a')
          }
          if (obj.botMetric.lastSuccessful) {
            obj.lastSuccessfulAtLocal = moment(obj.botMetric.lastSuccessful)
              .utc()
              .local()
              .format('DD MMM YYYY hh:mm:ss a')
          }
        } else {
          obj.successRate = 0
          obj.failureRate = 0
          obj.totalExecution = 0
          obj.avgExecutionTime = 0
          obj.effortSavings = 0
          obj.lastExecutedAtLocal = ''
          obj.lastFailedAtLocal = ''
          obj.lastSuccessfulAtLocal = ''
        }
      } else if (type === 'Hive') {
        obj.type = obj.hiveType
        obj.itemType = 'Hive'
        obj.createdAtLocal = moment(obj.createdAt)
          .utc()
          .local()
          .format('DD MMM YYYY hh:mm:ss a')
      }
      return obj
    },

    wordwrap(inputString, maxChar) {
      var sumLengthOfWords = function(wordArray) {
        var out = 0
        if (wordArray.length !== 0) {
          for (var i = 0; i < wordArray.length; i++) {
            var word = wordArray[i]
            out = out + word.length
          }
        }

        return out
      }

      var splitOut = [[]]
      var splitString = inputString.split(' ')
      for (var i = 0; i < splitString.length; i++) {
        var word = splitString[i]

        if (
          sumLengthOfWords(splitOut[splitOut.length - 1]) + word.length >
          maxChar
        ) {
          splitOut = splitOut.concat([[]])
        }

        splitOut[splitOut.length - 1] = splitOut[splitOut.length - 1].concat(
          word
        )
      }

      for (var j = 0; j < splitOut.length; j++) {
        splitOut[j] = splitOut[j].join(' ')
      }

      return splitOut.join('\n')
    }
  },
  computed: {
    ...mapState({
      hives: state => state.hives.hives,
      bots: state => state.bots.bots,
      botsWithProjection: state => state.bots.botsWithProjection,
      workflows: state => state.workflows.workflows,
      workflowsWithProjection: state => state.workflows.workflowsWithProjection
    }),
    ...mapGetters({
      can: 'can'
    })
  }
}
</script>

<style scoped>
.network {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
</style>
